import { Field, FieldTypes } from '@common-fe/common-fe';

import { DefaultValues } from '@/common/types';

export const getFieldsWithDefaultValues = (fields: Field[], defaultValues?: DefaultValues): Field[] => {
  if (defaultValues) {
    return fields.map((item) => {
      let subFields: Field[] | undefined;
      if (item.subFields) {
        subFields = getFieldsWithDefaultValues(item.subFields, defaultValues);
      }

      // For Checkbox fields, false is a valid value and should not be replaced with defaultValue
      let value;
      if (item.type === FieldTypes.Checkbox) {
        // For Checkbox: only use defaultValue if value is undefined or null
        value = item.value !== undefined && item.value !== null ? item.value : defaultValues[item.name] || '';
      } else {
        value = item.value || defaultValues[item.name] || '';
      }

      return {
        ...item,
        subFields,
        value,
      };
    });
  }
  return fields;
};

export default getFieldsWithDefaultValues;
